import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMovToMp4ConverterConfig } from '@/data/landingConfig/landingMovToMp4ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MovToMp4Converter } from './schemaObject';

interface Props {}
const MovToMp4Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MovToMp4Converter} />
			<VideoLandingTemplate
				data={landingMovToMp4ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default MovToMp4Converter;
